import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Services.module.css';

interface Tier {
  duration: string;
  price: string;
}

const Services: React.FC = () => {
  const { t } = useTranslation();

  const singles = ['service1', 'service2'];
  const tiers = t('Services.thai.tiers', { returnObjects: true }) as Tier[];

  return (
    <section id="services" className={classes.services}>
      <h2>{t('Services.title')}</h2>
      <div className={classes.menu}>
        {singles.map((key) => (
          <article key={key} className={classes.item}>
            <div className={classes.head}>
              <h3 className={classes.name}>{t(`Services.${key}.name`)}</h3>
              <span className={classes.rule} aria-hidden="true" />
              <span className={classes.duration}>
                {t(`Services.${key}.duration`)}
              </span>
              <span className={classes.price}>
                {t(`Services.${key}.price`)}
              </span>
            </div>
            <p className={classes.description}>
              {t(`Services.${key}.description`)}
            </p>
          </article>
        ))}

        <article className={classes.item}>
          <div className={classes.head}>
            <h3 className={classes.name}>{t('Services.thai.name')}</h3>
            <span className={classes.rule} aria-hidden="true" />
            <span className={classes.duration}>{t('Services.thai.range')}</span>
          </div>
          <p className={classes.description}>
            {t('Services.thai.description')}
          </p>
          <ul className={classes.tiers}>
            {tiers.map((tier) => (
              <li key={tier.duration} className={classes.tier}>
                <span className={classes.tierDuration}>{tier.duration}</span>
                <span className={classes.rule} aria-hidden="true" />
                <span className={classes.price}>{tier.price}</span>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
